"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
var commands_1 = require("./commands");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return commands_1.default; } });
